module.exports = __webpack_public_path__ + "static/media/dashboard.571f563a.svg";